import { getApiEndpoint } from '../config/api.js';

export interface VolatilityLiquidityStock {
  symbol: string;
  price: number;
  atr: number;
  atrPercent: number;
  volatilityRank: number;
  avgVolume30Day: number;
  avgDollarVolume: number;
  bidAskSpread: number;
  bidAskSpreadPercent: number;
  liquidityScore: number;
  optionsVolume?: number;
  recentVolatility: {
    daily: number;
    weekly: number;
    monthly: number;
  };
}

export interface MarketStats {
  avgATR: number;
  avgATRPercent: number;
  avgVolume: number;
  totalScanned: number;
  totalFiltered: number;
}

export interface VolatilityLiquidityResponse {
  filtered: VolatilityLiquidityStock[];
  marketStats: MarketStats;
  timestamp: string;
}

export interface VolatilityLiquidityFilters {
  atrMin?: number;
  atrMax?: number;
  atrPercentMin?: number;
  atrPercentMax?: number;
  avgVolumeMin?: number;
  bidAskSpreadMax?: number;
  period?: number;
  limit?: number;
}

export const marketAnalysisApi = {
  async getVolatilityLiquidityFilter(filters: VolatilityLiquidityFilters): Promise<VolatilityLiquidityResponse> {
    // Build query parameters
    const queryParams = new URLSearchParams();
    
    if (filters.atrMin !== undefined) queryParams.append('atrMin', filters.atrMin.toString());
    if (filters.atrMax !== undefined) queryParams.append('atrMax', filters.atrMax.toString());
    if (filters.atrPercentMin !== undefined) queryParams.append('atrPercentMin', filters.atrPercentMin.toString());
    if (filters.atrPercentMax !== undefined) queryParams.append('atrPercentMax', filters.atrPercentMax.toString());
    if (filters.avgVolumeMin !== undefined) queryParams.append('avgVolumeMin', filters.avgVolumeMin.toString());
    if (filters.bidAskSpreadMax !== undefined) queryParams.append('bidAskSpreadMax', filters.bidAskSpreadMax.toString());
    if (filters.period !== undefined) queryParams.append('period', filters.period.toString());
    if (filters.limit !== undefined) queryParams.append('limit', filters.limit.toString());
    
    const response = await fetch(`${getApiEndpoint()}/marketAnalysis?${queryParams.toString()}`);
    
    if (!response.ok) {
      throw new Error(`Market analysis API error: ${response.status} ${response.statusText}`);
    }
    
    const data = await response.json();
    return data;
  },
};